import { useTranslation } from 'react-i18next';
import { Table, Typography } from '@thinknet-gmbh/platform-common-ui';

import HealthInsuranceTableRowActions from './health-insurance-table-row-actions.component';

import { IHealthInsuranceTableProps } from './health-insurance-table.interfaces';

const HealthInsuranceTable = ({
  dataSource,
  paginationConfig,
  handleModals,
  onTableChange,
  loading,
}: IHealthInsuranceTableProps) => {
  const { t } = useTranslation(['common', 'employee']);

  return (
    <Table
      loading={loading}
      dataSource={dataSource}
      pagination={paginationConfig}
      rowKey={record => record._id}
      t={t}
    >
      <Table.Column
        title={t('settings:healthInsurance.labels.name')}
        sorter={onTableChange}
        render={({ name }) => <Typography>{name}</Typography>}
      />
      <Table.Column
        width={50}
        title={t('common:labels.action')}
        render={record => (
          <HealthInsuranceTableRowActions record={record} handleModals={handleModals} t={t} />
        )}
      />
    </Table>
  );
};

export default HealthInsuranceTable;
